import React, {useRef, useState} from 'react';
import {useHistory, useParams} from 'react-router-dom';

import CardsHeader from 'layouts/Headers/CardsHeader.js';

import {DealContextProvider} from './context';

import {Card, Col, Container, Row,} from "reactstrap";

import Tabs from 'views/pages/deals/tabs/Tabs'
import Content from 'views/pages/deals/tabs/Content'
import actions from "actions/index.js";
import {useDispatch} from "react-redux";
import {LoaderContainer, override} from "@pages/reusable-components/styled-components";
import {ClipLoader} from "react-spinners";

export default function DealEdit() {
  const { id } = useParams()
  const dispatch = useDispatch()
  const history = useHistory()
  const [showBackButton, setShowBackButton] = useState(false)
  const [loading, setLoading] = useState(true)

  const clearMenus = () => {
    dispatch(actions.setMenusList([]))
    dispatch(actions.setMenuName(null))
    dispatch(actions.setActiveMenu(null))
    history.push(`/admin/deals`)
  }

  return (
    <DealContextProvider id={id} setLoading={setLoading}>
      {
        loading ?
          <LoaderContainer>
            <ClipLoader
              css={override}
              size={40}
              color={`#7B61E4`}
              loading={loading}
            />
          </LoaderContainer> :
          <>
            <CardsHeader name="Deal Management"
              parentName="Deals Management"
              currentName="Edit"
              backButtonText={'Back to Deals'}
              showBackButton={showBackButton}
              redirect={clearMenus} />

            <Container className="mt--5 admin-main-body" fluid >
              <Row>
                <Col md={12} xl={12}>
                  <Tabs activateTab={setShowBackButton} />
                  <Card>
                    <Content />
                  </Card>
                </Col>
              </Row>
            </Container>
          </>
      }
    </DealContextProvider>
  )
}